module.exports = __webpack_public_path__ + "static/media/victorian-earing_720x480.30afb12b.jpg";